module.exports = __webpack_public_path__ + "static/media/dramaImg8.e58e725d.jpg";